import gsap from "gsap";
import { lockScroll, unlockScroll } from "../../utils/Scroll";
import { openModalBackdrop, closeModalBackdrop, announceOverlay } from "../../utils/ModalBackdrop";
import { BP } from "../../utils/breakpoints";
import { getCart } from "../../utils/cart-fragments";
import { pushCartEvent } from "../../utils/data-layer";

const CLOSE_SCALE = 1.5;

export default class SideCart {
  constructor(el) {
    this.el = el;
    this.panel = el.querySelector(".c-side-cart__panel");
    this.overlay = el.querySelector("[data-side-cart-overlay]");
    this.closeBtn = el.querySelector("[data-side-cart-close]");

    this.isOpen = false;
    this.lastTrigger = null;
    this._tl = null;

    this.setup();
    this.init();
  }

  setup() {
    gsap.set(this.el, { autoAlpha: 0 });
    gsap.set(this.overlay, { opacity: 0 });
    gsap.set(this.panel, { xPercent: 100 });
  }

  init() {
    document.querySelectorAll("[data-cart-toggle]").forEach((trigger) => {
      trigger.addEventListener("click", () => {
        this.lastTrigger = trigger;
        // view_cart only when the customer opens the cart themselves, not on
        // the auto-open after an add to cart. Nothing is sent for an empty cart.
        if (!this.isOpen) pushCartEvent("view_cart", getCart());
        this.open();
      });
    });

    this.overlay.addEventListener("click", () => this.close());
    this.closeBtn.addEventListener("click", () => this.close());

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.isOpen) this.close();
    });

    // Ouverture auto à l'ajout au panier (event jQuery WooCommerce)
    if (window.jQuery) {
      window.jQuery(document.body).on("added_to_cart", () => this.open());
    }
  }

  open() {
    if (this.isOpen) return;
    if (this._tl) this._tl.kill();

    this.isOpen = true;
    // Full-screen panel on mobile: nothing behind it to pixelate.
    if (window.matchMedia(BP.mobile).matches) announceOverlay(this);
    else openModalBackdrop(this);
    this.el.classList.remove("is-closing");
    this.el.classList.add("is-open");
    this.el.setAttribute("aria-hidden", "false");
    lockScroll();

    this._tl = gsap
      .timeline()
      .set(this.el, { autoAlpha: 1 })
      .to(this.overlay, { opacity: 1, duration: 0.3, ease: "power2.out" }, 0)
      .to(this.panel, { xPercent: 0, duration: 0.68, ease: "jitterSmooth" }, 0);

    this.closeBtn.focus();
  }

  close() {
    if (!this.isOpen) return;
    if (this._tl) this._tl.kill();

    this.isOpen = false;
    this.el.classList.remove("is-open");
    this.el.classList.add("is-closing");
    this.el.setAttribute("aria-hidden", "true");
    unlockScroll();
    closeModalBackdrop(this);

    this._tl = gsap
      .timeline({
        onComplete: () => {
          this.el.classList.remove("is-closing");
          gsap.set(this.el, { autoAlpha: 0 });
        },
      })
      .to(this.overlay, { opacity: 0, duration: 0.3 / CLOSE_SCALE, ease: "power2.in" }, 0)
      .to(this.panel, { xPercent: 100, duration: 0.68 / CLOSE_SCALE, ease: "jitterSmooth" }, 0);

    if (this.lastTrigger) this.lastTrigger.focus();
  }
}
